import { type SeriesModel } from 'echarts';
import { graphic } from 'echarts/core';

export class Line {
  lineModel: SeriesModel;

  options: any;

  line: graphic.Line;

  constructor(zr, lineModel: SeriesModel, options) {
    this.lineModel = lineModel;
    this.options = options;
    this.line = null;

    this.init(zr, options);
  }

  init(zr, options) {
    this.draw(options);
    zr.add(this.line);
  }

  draw(options) {
    const line = new graphic.Line({
      shape: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      },
      style: options.style,
      zlevel: -1
    });
    this.line = line;
  }

  move(position) {
    const [x] = position;
    const rect = this.lineModel.getBaseAxis().grid.getRect();
    const { height, y } = rect;
    this.line.attr({
      shape: {
        x1: x,
        y1: y,
        x2: x,
        y2: y + height
      }
    });
  }
}
